import { EntityRequestOvertime } from "../../entity/EntityRequestOvertime";

export class DtoRequestOvertimesDeleteRes extends EntityRequestOvertime {
  public message: string | null = null;
}
